import React, { Component } from 'react';


import * as img from '../../lib/images';
import * as env from '../../lib/environment';

import MyButton from '../button'

const outProduct = (props) => {
    if(props.isMobile) {
        return (
            <div className="d-flex headerSection align-items-center ">
                <div className="col-12 p-0 h-100 d-flex justify-content-center flex-column">
                     <div className="w-100 justify-content-center d-flex">
                        <p className="m-0" style={{ fontSize: '2.5rem', fontWeight: "bold",color:"#212529" }}>Our Product</p>
                    </div>
                    <div style={{ padding: "1rem 0rem" }}>
                        <p className="m-0" style={{ fontSize: "0.9rem",textAlign:"center" }}>Our integrated and end-to-end self storage software allows owners and managers to focus on running the business by automating day-to-day operations. Our suite of B2B and B2C products will enable businesses to continue providing an excellent service to their communities by streamlining the increasingly complex operations of the self storage industry. </p>
                    </div>
                    <div data-aos="fade-up" className="w-100 d-flex py-3  justify-content-center ">
                    <img className="headerLogo" src={img.OUR_PRODUCT} />
                </div>
                <div className="w-100 d-flex pt-3 justify-content-center ">
                <MyButton value="View More"/>
                </div>
                   
                </div>
                
    
            </div>
        )
    }
    else{
        return (
            <div ref={props.setOurProductRef} className="d-flex headerSection align-items-center ">
                <div className="col-6 p-0 h-100 d-flex justify-content-center flex-column">
                    <div>
                        <p className="m-0" style={{ fontSize: '2.5rem', fontWeight: "bold",color:"#212529" }}>Our Product</p>
                    </div>
                    <div style={{ padding: "4rem 0rem" }}>
                        <p className="m-0" style={{ fontSize: "0.9rem" }}>Our integrated and end-to-end self storage software allows owners and managers to focus on running the business by automating day-to-day operations. Our suite of B2B and B2C products will enable businesses to continue providing an excellent service to their communities by streamlining the increasingly complex operations of the self storage industry. </p>
                    </div>
                   <MyButton value="View More"/>
                </div>
                <div data-aos="fade-up" className="col-6 d-flex  justify-content-end px-0 py-3 h-100">
                    <img className="headerLogo" src={img.OUR_PRODUCT} />
                </div>
    
            </div>
        )
    }
    
}

export default outProduct;